"use client";

interface DesktopMenuToggleProps {
  isOpen: boolean;
  onToggle: () => void;
  disabled?: boolean;
}

export function DesktopMenuToggle({
  isOpen,
  onToggle,
  disabled,
}: DesktopMenuToggleProps) {
  return (
    <div
      onClick={() => {
        if (disabled) return;
        onToggle();
      }}
      className={`menu-toggle ${isOpen ? "opened" : "closed"} bg-background ease-in`}
    >
      <div className="menu-toggle-icon bg-primary transition-all duration-500 ease-in">
        <div className="hamburger">
          <div className="menu-bar" data-position="top"></div>
          <div className="menu-bar" data-position="bottom"></div>
        </div>
      </div>
      <div className="menu-copy ease-in">
        <p className="uppercase text-sm text-surface">Menu</p>
      </div>
    </div>
  );
}
